import React from 'react'
import IconBase from 'react-icon-base';

const Us = (props) => {
  return (
    <IconBase {...props} viewBox='0 0 512 512'>
      <path d='M473.069,421.161H38.931c-16.94,0-30.673-13.733-30.673-30.673V121.511	c0-16.94,13.733-30.673,30.673-30.673h434.137c16.94,0,30.673,13.733,30.673,30.673v268.976	C503.742,407.428,490.009,421.161,473.069,421.161z'
        fill='#164fce' />
      <polygon points='503.742,211.406 239.917,211.406 239.917,90.838 150.73,90.838 150.73,211.406 8.258,211.406 8.258,300.593 150.73,300.593 150.73,421.161 239.917,421.161 239.917,300.593 503.742,300.593'
        fill='#fff' />
      <polygon points='503.742,232.051 219.271,232.051 219.271,90.838 171.375,90.838 171.375,232.051 8.258,232.051 8.258,279.948 171.375,279.948 171.375,421.161 219.271,421.161 219.271,279.948 503.742,279.948'
        fill='#ed1f34' />
      <path d='M469.766,82.58H42.234C18.946,82.58,0,101.526,0,124.814v262.371	c0,23.288,18.946,42.234,42.234,42.234h427.531c23.288,0,42.234-18.946,42.234-42.234V124.814	C512,101.526,493.054,82.58,469.766,82.58z M495.484,124.814v98.979H227.53V99.096h242.237	C483.947,99.096,495.484,110.633,495.484,124.814z M42.234,99.096h120.882v124.697H16.516v-98.979	C16.516,110.633,28.053,99.096,42.234,99.096z M16.516,387.185v-98.979h146.6v124.697H42.234	C28.053,412.903,16.516,401.366,16.516,387.185z M469.766,412.903H227.53V288.206h177.116c4.561,0,8.258-3.697,8.258-8.258	c0-4.561-3.697-8.258-8.258-8.258H219.271c-4.561,0-8.258,3.697-8.258,8.258v132.955h-31.381V279.948	c0-4.561-3.697-8.258-8.258-8.258H16.516v-31.381h154.859c4.561,0,8.258-3.697,8.258-8.258V99.096h31.381v132.955	c0,4.561,3.697,8.258,8.258,8.258h276.212v31.381h-57.806c-4.561,0-8.258,3.697-8.258,8.258c0,4.561,3.697,8.258,8.258,8.258h57.806	v98.979C495.484,401.366,483.947,412.903,469.766,412.903z'
        fill='#121b21' />
    </IconBase>
  )
}

export default Us;



// WEBPACK FOOTER //
// ./src/components/Header/flags/is.js